/* Brightcove player renders twice in strict mode: remove one copy */
.brightcove > div > * + * {
  display: none;
}

.brightcove {
  aspect-ratio: 16 / 9;
}

.brightcove > div {
  height: 100%;
}

.brightcove > div > * {
  height: 100%;
  width: 100%;
}
